exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fixHeader{position:fixed;right:25px;top:50px;background-color:#353942!important;z-index:5}#fix-header{height:72px;padding-top:20px;border-bottom:1px solid #292c33}#fix-content{height:72px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/Fixheader.vue
 ** module id = 100
 ** module chunks = 0
 **/